import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'
import { Kegmeisters } from '../Keg'
import { push } from 'react-router-redux'
import { Link } from 'react-router-dom'

export default class InternalNavigation extends Component {
  render () {
    return (
      <div className='km-header'>
        <div className='left'>
          <FontAwesome
            onClick={this.props.toggleDrawer}
            className='hamburger'
            name='bars'
            size='2x' />
        </div>
        <div className='center'>
          <Link to='/reservations'>
            <Kegmeisters
              fontSize={22}
              kegClassName={'d-inline-block'}
              wrapperClassName={'homebutton d-inline-block'}
              meistersClassName={'d-inline-block'}
              kegColor={'#FDBF20'}
              meistersColor={'#FFFFFF'}
            />
          </Link>
        </div>
        <div className='right'>
          <div className='edit'>
            <div style={{color: 'white'}}>
              &nbsp;
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/InternalNavigation/index.js